/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import React from 'react';

/**
 * MaterialRounded Switch Access Shortcut.
 * @export
 */
export const ICON_SWITCH_ACCESS_SHORTCUT = (
  <svg
    enableBackground="new 0 0 24 24"
    fill="#000000"
    height="24px"
    viewBox="0 0 24 24"
    width="24px"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect fill="none" height="24" width="24" />
    <path d="M7.06 8.94L5 8L7.06 7.06L8 5L8.94 7.06L11 8L8.94 8.94L8 11L7.06 8.94ZM8 21L8.94 18.94L11 18L8.94 17.06L8 15L7.06 17.06L5 18L7.06 18.94L8 21ZM4.37 12.37L3 13L4.37 13.63L5 15L5.63 13.63L7 13L5.63 12.37L5 11L4.37 12.37ZM19 20.41C19 21.19 18.16 21.66 17.49 21.27C14.21 19.36 12 15.79 12 12C12 9.27 13.08 6.73 14.75 4.75L12.85 2.85C12.54 2.54 12.76 2 13.21 2H18.5C18.78 2 19 2.22 19 2.5V7.79C19 8.24 18.46 8.46 18.15 8.14L16.18 6.17C14.84 7.82 14 9.88 14 12C14 15.13 15.86 18.01 18.51 19.55C18.81 19.73 19 20.06 19 20.41Z" />
  </svg>
);
